export const SessionManager = {
    logout,
    isAuthenticated,
    getToken,
    getTokenKey,
    getTokenKeyExpired,
    isExpired,
    setExpired,
    setTokenKey,
    setTokenKeyExpired,
    setAppSlug,
    getAppSlug
};

let tokenKey = 'auth-token';
let tokenKeyExpired = 'token-expired';
let appSlug = null;


function logout() {
    // remove user from local storage to log user out
    localStorage.removeItem(tokenKey);
    localStorage.removeItem(tokenKeyExpired);
}

function setAppSlug(newAppSlug) {
    appSlug = newAppSlug;
}

function getAppSlug() {
    return appSlug;
}

function setTokenKey(newTokenKey) {
    tokenKey = newTokenKey;
}

function getTokenKey() {
    return tokenKey;
}

function getTokenKeyExpired() {
    return tokenKeyExpired;
}

function setTokenKeyExpired(newTokenKeyExpired) {
    tokenKeyExpired = newTokenKeyExpired;
}

function isAuthenticated() {
    return !!localStorage.getItem(tokenKey);
}

function isExpired() {
    return localStorage.getItem(tokenKeyExpired) === 'true';
}

function getToken() {
    return localStorage.getItem(tokenKey);
}

function setExpired(expired) {
    localStorage.setItem(tokenKeyExpired, expired);
}